// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"87fcda68","299":"ec052197","453":"e4c980df","667":"c08db3d2","859":"a75cdf08","977":"145b06bf"}[chunkId] + ".chunk.js";
};